export default __webpack_public_path__ + "static/media/dashboard.d32b4703.png";